import { render, staticRenderFns } from "./pago.vue?vue&type=template&id=57625167&"
import script from "./pago.vue?vue&type=script&lang=js&"
export * from "./pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports